<template>
  <div
    :id="module.id"
    class="keen-slider__slide module-slider-slide"
    :data-testid="'slide-' + module.id"
  >
    <div class="slide-wrapper">
      <div
        class="image-wrapper"
        :class="'ratio-' + parent.config.general.template.component"
        :style="imageWrapElStyles"
      >
        <Video
          :module="module"
          :lazy="lazy"
          :is-slider-module="true"
          :parent="parent"
        />
      </div>

      <div
        class="text-wrapper"
        :class="'ratio-' + parent.config.general.template.component"
        :style="textWrapElStyles">
        <div
          v-if="parent.config.general.showHeader"
          class="headline"
          :style="headerElStyles"
          v-html="module.config.header.text"
        ></div>
        <div
          v-if="parent.config.general.showBody"
          class="text"
          :style="textElStyles"
          v-html="module.config.text.text"
        ></div>

        <GlobalUICtaButton
          v-if="parent.config.general.showButton"
          :ctaButton="module.config.ctaButton"
          @click="$emit('emittedClick')"
        />
      </div>
    </div>
  </div>
</template>

<script>
import GlobalUICtaButton from "../../GlobalUI/GlobalUICtaButton.vue";
import Video from "../../Video/Video.vue";

export default {
  name: "VideoSlide",
  components: { GlobalUICtaButton, Video },
  props: {
    module: {
      type: Object,
      default: () => {
        return {};
      },
    },
    parent: {
      type: Object,
      default() {
        return {};
      },
    },
    lazy: {
      type: Boolean,
      default: false,
    },
  },
  emits: ["emittedClick"],
  computed: {
    imageWrapElStyles() {
      const { corners } = this.parent.config.general;

      const styles = {
        borderRadius:
          corners.value === "round" ? "var(--cr-border-radius-large)" : "0px",
      };

      return styles;
    },
    textWrapElStyles() {
      const styles = {
        alignItems:
          this.parent.config.general.textAlign.value == "left"
            ? "flex-start"
            : "center",
      };

      return styles;
    },
    headerElStyles() {
      const { isTextInCaps, textColor } = this.module.config.header;

      const styles = {
        textTransform: isTextInCaps ? "uppercase" : "initial",
        color: textColor.value,
        textAlign: this.parent.config.general.textAlign.value,
      };
      return styles;
    },
    textElStyles() {
      const { textColor } = this.module.config.text;

      const styles = {
        color: textColor.value,
        textAlign: this.parent.config.general.textAlign.value,
      };
      return styles;
    },
    imageWidths() {
      switch (this.parent.config.general.template.component) {
        case "SixteenToNine":
          return {
            mobile: 350,
            tablet: 600,
            laptop: 860,
            desktop: 860,
          };
        case "FourToThree":
          return {
            mobile: 350,
            tablet: 675,
            laptop: 675,
            desktop: 675,
          };
        case "OneToOne":
          return {
            mobile: 350,
            tablet: 500,
            laptop: 500,
            desktop: 500,
          };
        case "NineToSixteen":
          return {
            mobile: 350,
            tablet: 350,
            laptop: 350,
            desktop: 350,
          };
      }
    },
  },
};
</script>

<style scoped lang="scss">
@import "./shared.scss";
</style>
